import { Box, Flex, Text } from '@chakra-ui/react';
import { MediaImageXmark } from 'iconoir-react';
import { useTranslation } from 'react-i18next';

interface MentionMediaUnavailableProps {
  /** The media is known to have lapsed rather than merely missing. */
  expired?: boolean;
  width?: string;
}

/**
 * What stands in for a mention picture nothing can draw.
 *
 * Shared by every surface that shows mention media, because the alternative is
 * an `<img>` pointing at nothing: browsers draw a broken-file glyph for it, and
 * a grid of those reads as a bug in the product rather than as media the
 * platform stopped serving.
 */
export function MentionMediaUnavailable({
  expired = false,
  width = '100%',
}: MentionMediaUnavailableProps) {
  const { t } = useTranslation();

  return (
    <Box
      bg="softCream"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={2}
      width={width}
      height="100%"
      color="primary.400"
    >
      <Flex
        align="center"
        justify="center"
        boxSize="40px"
        rounded="lg"
        bg="panelBg"
        borderWidth="1px"
        borderColor="border"
      >
        <MediaImageXmark width={19} height={19} />
      </Flex>
      <Text fontSize="xs" color="primary.400">
        {expired ? t('mentions.media.expired') : t('mentions.media.unavailable')}
      </Text>
    </Box>
  );
}

export default MentionMediaUnavailable;
